 
import { Typography } from '@HomaHealth/ui-component-library';
import { Chip } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';

export const getPlaybookStatusChip = (label: any) => {
  let textColor: any = '';
  let backgroundColor: any = '';
  switch (label) {
    // new status
    case 'Fiduciary':
      textColor = patientAccessTheme.palette.warning[400];
      backgroundColor = '#feffe6';
      break;
    case 'Compliance':
      textColor = patientAccessTheme.palette.text?.mediumemphasis;
      backgroundColor = '#545F8E33';
      break;
    case 'Liability':
      textColor = patientAccessTheme.palette.status.error400;
      backgroundColor = '#fff2f3';
      break;
    case 'Indemnification':
      textColor = patientAccessTheme.palette.warning[400];
      backgroundColor = '#feffe6';
      break;
    case 'Cost':
      textColor = '#008272';
      backgroundColor = '#00827233';
      break;
    default:
      textColor = patientAccessTheme.palette.AIQChips?.textColor3;
      backgroundColor = patientAccessTheme.palette.AIQChips?.background3;
      break;
  }
  return (
    <Chip
      height="27px"
      borderRadius="8px"
      label={
        <Typography
          fontSize="12px"
          fontType="medium"
          lineHeight="21.24px"
          textColor={textColor}
        >
          {label}
        </Typography>
      }
      backgroundColor={backgroundColor}
      border={`1px solid ${textColor}`}
    />
  );
};
